import { createIcon } from './createIcon';

export const MoneyIcon = createIcon({
  name: 'money',
  transform: '',
  path: (
    <path
      d="M11 11.5H12.5V10M11 5.5H12.5V7M4 5.5H2.5V7M2.5 10V11.5H4M7.5 10.5C6.96957 10.5 6.46086 10.2893 6.08579 9.91421C5.71071 9.53914 5.5 9.03043 5.5 8.5C5.5 7.96957 5.71071 7.46086 6.08579 7.08579C6.46086 6.71071 6.96957 6.5 7.5 6.5C8.03043 6.5 8.53914 6.71071 8.91421 7.08579C9.28929 7.46086 9.5 7.96957 9.5 8.5C9.5 9.03043 9.28929 9.53914 8.91421 9.91421C8.53914 10.2893 8.03043 10.5 7.5 10.5ZM1.5 3.5H13.5C13.7652 3.5 14.0196 3.60536 14.2071 3.79289C14.3946 3.98043 14.5 4.23478 14.5 4.5V12.5C14.5 12.7652 14.3946 13.0196 14.2071 13.2071C14.0196 13.3946 13.7652 13.5 13.5 13.5H1.5C1.23478 13.5 0.98043 13.3946 0.792893 13.2071C0.605357 13.0196 0.5 12.7652 0.5 12.5V4.5C0.5 4.23478 0.605357 3.98043 0.792893 3.79289C0.98043 3.60536 1.23478 3.5 1.5 3.5Z"
      stroke="currentColor"
    />
  )
});

export const InsuranceIcon = createIcon({
  name: 'insurance',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790177 3.60322 0 5.51088 0 7.5C0 8.48491 0.193993 9.46018 0.570903 10.3701C0.947814 11.2801 1.50026 12.1069 2.1967 12.8033C2.89314 13.4997 3.71993 14.0522 4.62987 14.4291C5.53982 14.806 6.51509 15 7.5 15C8.48491 15 9.46018 14.806 10.3701 14.4291C11.2801 14.0522 12.1069 13.4997 12.8033 12.8033C13.4997 12.1069 14.0522 11.2801 14.4291 10.3701C14.806 9.46018 15 8.48491 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0ZM2.90381 2.90381C4.12279 1.68482 5.77609 1 7.5 1C9.22391 1 10.8772 1.68482 12.0962 2.90381C13.3152 4.12279 14 5.77609 14 7.5C14 8.35359 13.8319 9.19883 13.5052 9.98744C13.1786 10.7761 12.6998 11.4926 12.0962 12.0962C11.4926 12.6998 10.7761 13.1786 9.98744 13.5052C9.19883 13.8319 8.35359 14 7.5 14C6.64641 14 5.80117 13.8319 5.01256 13.5052C4.22394 13.1786 3.50739 12.6998 2.90381 12.0962C2.30022 11.4926 1.82144 10.7761 1.49478 9.98744C1.16813 9.19883 1 8.35359 1 7.5C1 5.77609 1.68482 4.12279 2.90381 2.90381ZM5.1503 5.65541C5.26121 5.60946 5.3801 5.58582 5.50015 5.58582C5.74262 5.58582 5.97515 5.68213 6.1466 5.85358L7.1466 6.85358L7.50015 7.20714L7.8537 6.85358L8.8537 5.85358C9.02515 5.68213 9.25769 5.58582 9.50015 5.58582C9.74262 5.58582 9.97515 5.68213 10.1466 5.85358C10.318 6.02503 10.4144 6.25756 10.4144 6.50003C10.4144 6.74249 10.318 6.97503 10.1466 7.14648L7.50015 9.79292L4.8537 7.14648C4.68226 6.97503 4.58594 6.74249 4.58594 6.50003C4.58594 6.37997 4.60958 6.26109 4.65553 6.15018C4.70147 6.03926 4.76881 5.93847 4.8537 5.85358C4.9386 5.76869 5.03938 5.70135 5.1503 5.65541ZM5.50015 4.58582C5.24877 4.58582 4.99986 4.63533 4.76761 4.73153C4.53537 4.82772 4.32435 4.96872 4.1466 5.14648C3.96885 5.32423 3.82785 5.53525 3.73165 5.76749C3.63545 5.99973 3.58594 6.24865 3.58594 6.50003C3.58594 7.00771 3.78761 7.4946 4.1466 7.85358L7.1466 10.8536L7.50015 11.2071L7.8537 10.8536L10.8537 7.85358C11.2127 7.4946 11.4144 7.00771 11.4144 6.50003C11.4144 5.99235 11.2127 5.50546 10.8537 5.14648C10.4947 4.78749 10.0078 4.58582 9.50015 4.58582C8.99247 4.58582 8.50558 4.78749 8.1466 5.14648L7.50015 5.79292L6.8537 5.14648C6.49472 4.78749 6.00783 4.58582 5.50015 4.58582Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const PTOIcon = createIcon({
  name: 'pto',
  transform: '',
  path: (
    <path
      d="M7.5 7.5H7C6.99988 7.5657 7.01272 7.63079 7.03777 7.69153C7.06282 7.75227 7.0996 7.80748 7.146 7.854L7.5 7.5ZM7.5 14C5.77609 14 4.12279 13.3152 2.90381 12.0962C1.68482 10.8772 1 9.22391 1 7.5H0C0 9.48912 0.790176 11.3968 2.1967 12.8033C3.60322 14.2098 5.51088 15 7.5 15V14ZM14 7.5C14 8.35359 13.8319 9.19883 13.5052 9.98744C13.1786 10.7761 12.6998 11.4926 12.0962 12.0962C11.4926 12.6998 10.7761 13.1786 9.98744 13.5052C9.19883 13.8319 8.35359 14 7.5 14V15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5H14ZM7.5 1C8.35359 1 9.19883 1.16813 9.98744 1.49478C10.7761 1.82144 11.4926 2.30023 12.0962 2.90381C12.6998 3.50739 13.1786 4.22394 13.5052 5.01256C13.8319 5.80117 14 6.64641 14 7.5H15C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0V1ZM7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5H1C1 5.77609 1.68482 4.12279 2.90381 2.90381C4.12279 1.68482 5.77609 1 7.5 1V0ZM7 3V7.5H8V3H7ZM7.146 7.854L10.146 10.854L10.854 10.146L7.854 7.146L7.146 7.854V7.854Z"
      fill="currentColor"
    />
  )
});

export const RemoteWorkIcon = createIcon({
  name: 'remote-work',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M1.43934 1.43934C1.72064 1.15804 2.10218 1 2.5 1H12.5C12.8978 1 13.2794 1.15804 13.5607 1.43934C13.842 1.72064 14 2.10218 14 2.5V10.5C14 10.8978 13.842 11.2794 13.5607 11.5607C13.2794 11.842 12.8978 12 12.5 12H2.5C2.10217 12 1.72064 11.842 1.43934 11.5607C1.15804 11.2794 1 10.8978 1 10.5V2.5C1 2.10218 1.15804 1.72064 1.43934 1.43934ZM2.5 2C2.36739 2 2.24021 2.05268 2.14645 2.14645C2.05268 2.24021 2 2.36739 2 2.5V10.5C2 10.6326 2.05268 10.7598 2.14645 10.8536C2.24021 10.9473 2.36739 11 2.5 11H12.5C12.6326 11 12.7598 10.9473 12.8536 10.8536C12.9473 10.7598 13 10.6326 13 10.5V2.5C13 2.36739 12.9473 2.24021 12.8536 2.14645C12.7598 2.05268 12.6326 2 12.5 2H2.5ZM0 13H15V14H0V13Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const BankIcon = createIcon({
  name: 'bank',
  transform: '',
  path: (
    <path
      d="M13.125 6.09375V14.5312M0.46875 14.5312H14.5312H0.46875ZM1.875 4.21875L7.5 1.40625L13.125 4.21875H1.875ZM0.46875 6.09375H14.5312H0.46875ZM5.625 8.4375V12.1875V8.4375ZM9.375 8.4375V12.1875V8.4375ZM1.875 6.09375V14.5312V6.09375Z"
      stroke="currentColor"
      strokeWidth="0.9375"
    />
  )
});

export const WorkstationIcon = createIcon({
  name: 'workstation',
  transform: '',
  path: (
    <path
      d="M1.50015 8.50003L1.10515 8.19303C1.03046 8.28918 0.993414 8.40927 1.00096 8.53078C1.00851 8.65229 1.06013 8.76687 1.14615 8.85303L1.50015 8.50003ZM6.50015 1.50003L6.14615 1.85403L6.50015 1.50003ZM8.50015 3.50003L8.85415 3.85403L9.20715 3.50003L8.85415 3.14603L8.50015 3.50003ZM6.50015 5.50003L6.14615 5.85403L6.50015 6.20703L6.85415 5.85403L6.50015 5.50003ZM4.50015 3.50003L4.14615 3.85403L4.50015 3.50003ZM7.63615 4.36403L7.99015 4.71703L7.63615 4.36403ZM7.36415 4.63603L7.01015 4.28303L7.36415 4.63603ZM7.63615 10.364L7.28315 10.01L7.63615 10.364ZM13.3641 4.63603L13.0101 4.28303L13.3641 4.63603ZM13.3641 4.36403L13.0101 4.71703L13.3641 4.36403ZM7.36415 10.364L7.71715 10.01L7.36415 10.364ZM2.00015 15H13.0001V14H2.00015V15ZM7.85415 14.146L1.85415 8.14603L1.14615 8.85403L7.14615 14.854L7.85415 14.147V14.146ZM1.89415 8.80703L5.39415 4.30703L4.60515 3.69303L1.10515 8.19303L1.89515 8.80703H1.89415ZM6.14615 1.85403L8.14615 3.85403L8.85415 3.14603L6.85415 1.14603L6.14615 1.85403V1.85403ZM8.14615 3.14603L6.14615 5.14603L6.85415 5.85403L8.85415 3.85403L8.14615 3.14603ZM6.85415 5.14603L4.85415 3.14603L4.14615 3.85403L6.14615 5.85403L6.85415 5.14603ZM4.85415 1.85403C5.02553 1.68281 5.25789 1.58663 5.50015 1.58663C5.74241 1.58663 5.97477 1.68281 6.14615 1.85403L6.85415 1.14603C6.6764 0.968124 6.46532 0.826989 6.233 0.730695C6.00067 0.634402 5.75164 0.584839 5.50015 0.584839C5.24866 0.584839 4.99963 0.634402 4.7673 0.730695C4.53498 0.826989 4.3239 0.968124 4.14615 1.14603L4.85415 1.85403ZM4.14615 1.14603C3.96824 1.32379 3.8271 1.53486 3.73081 1.76719C3.63452 1.99952 3.58495 2.24854 3.58495 2.50003C3.58495 2.75153 3.63452 3.00055 3.73081 3.23288C3.8271 3.46521 3.96824 3.67628 4.14615 3.85403L4.85415 3.14603C4.68292 2.97465 4.58674 2.7423 4.58674 2.50003C4.58674 2.25777 4.68292 2.02542 4.85415 1.85403L4.14615 1.14603V1.14603ZM7.28315 4.01003L7.01015 4.28303L7.71715 4.99003L7.99015 4.71703L7.28315 4.01003ZM7.99015 10.717L13.7171 4.99003L13.0101 4.28303L7.28315 10.01L7.99015 10.717V10.717ZM13.7171 4.99003C13.9871 4.72003 13.9871 4.28003 13.7171 4.01003L13.0101 4.71703C12.9526 4.65947 12.9203 4.58142 12.9203 4.50003C12.9203 4.41865 12.9526 4.3406 13.0101 4.28303L13.7171 4.99003V4.99003ZM7.01015 10.717C7.28015 10.987 7.72015 10.987 7.99015 10.717L7.28315 10.01C7.40315 9.89003 7.59715 9.89003 7.71715 10.01L7.01015 10.717V10.717ZM7.01015 4.28303C6.15706 5.1363 5.67782 6.29346 5.67782 7.50003C5.67782 8.7066 6.15706 9.86377 7.01015 10.717L7.71715 10.01C7.05154 9.3443 6.67761 8.44144 6.67761 7.50003C6.67761 6.55863 7.05154 5.65577 7.71715 4.99003L7.01015 4.28303ZM7.99015 4.71703C8.65588 4.05142 9.55874 3.67749 10.5001 3.67749C11.4416 3.67749 12.3444 4.05142 13.0101 4.71703L13.7171 4.01003C12.8639 3.15695 11.7067 2.67771 10.5001 2.67771C9.29358 2.67771 8.13641 3.15695 7.28315 4.01003L7.99015 4.71703Z"
      fill="currentColor"
    />
  )
});

export const ArrowRightIcon = createIcon({
  name: 'arrow-right',
  transform: '',
  path: (
    <path
      d="M13.5 7.5H1M13.5 7.5L9.5 3.5L13.5 7.5ZM13.5 7.5L9.5 11.5L13.5 7.5Z"
      stroke="currentColor"
    />
  )
});

export const ArrowLeftIcon = createIcon({
  name: 'arrow-left',
  transform: '',
  path: (
    <path
      d="M2.107 8.00403L1.75299 7.65003L1.39999 8.00403L1.753 8.35803L2.107 8.00403ZM2.46099 8.35803L6.46099 4.35803L5.75299 3.65003L1.75299 7.65003L2.46099 8.35803ZM1.753 8.35803L5.75299 12.358L6.46099 11.65L2.461 7.65003L1.753 8.35803ZM2.10699 8.50403L14.607 8.50403L14.607 7.50403L2.10699 7.50403L2.10699 8.50403Z"
      fill="currentColor"
    />
  )
});

export const ArrowTopRightIcon = createIcon({
  name: 'arrow-top-right',
  transform: '',
  path: (
    <path
      d="M11.4986 3.49866L11.9992 3.49866L11.9985 2.99873L11.4986 2.99803L11.4986 3.49866ZM10.9979 3.49866L10.9972 9L11.9985 9L11.9992 3.49866L10.9979 3.49866ZM11.4986 2.99803L5.99941 2.99888V4.00014L11.4986 3.99929L11.4986 2.99803ZM11.145 3.14511L2.30618 11.9839L3.01328 12.691L11.8521 3.85221L11.145 3.14511Z"
      fill="currentColor"
    />
  )
});

export const HeadphonesIcon = createIcon({
  name: 'headphones',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M7.5 1C6.04131 1 4.64236 1.57946 3.61091 2.61091C2.57946 3.64236 2 5.04131 2 6.5V9H2.5C2.89783 9 3.27936 9.15804 3.56066 9.43934C3.84196 9.72064 4 10.1022 4 10.5V13.5C4 13.8978 3.84196 14.2794 3.56066 14.5607C3.27936 14.842 2.89783 15 2.5 15H1.5C1.10217 15 0.720644 14.842 0.43934 14.5607C0.158035 14.2794 0 13.8978 0 13.5V10.5C0 10.1022 0.158035 9.72064 0.43934 9.43934C0.599042 9.27964 0.791048 9.15967 1 9.08579V6.5C1 4.77609 1.68482 3.12279 2.90381 1.90381C4.12279 0.684819 5.77609 0 7.5 0C9.22391 0 10.8772 0.684819 12.0962 1.90381C13.3152 3.12279 14 4.77609 14 6.5V9.08579C14.209 9.15967 14.401 9.27964 14.5607 9.43934C14.842 9.72064 15 10.1022 15 10.5V13.5C15 13.8978 14.842 14.2794 14.5607 14.5607C14.2794 14.842 13.8978 15 13.5 15H12.5C12.1022 15 11.7206 14.842 11.4393 14.5607C11.158 14.2794 11 13.8978 11 13.5V10.5C11 10.1022 11.158 9.72064 11.4393 9.43934C11.7206 9.15804 12.1022 9 12.5 9H13V6.5C13 5.04131 12.4205 3.64236 11.3891 2.61091C10.3576 1.57946 8.95869 1 7.5 1ZM1.5 10C1.36739 10 1.24022 10.0527 1.14645 10.1464C1.05268 10.2402 1 10.3674 1 10.5V13.5C1 13.6326 1.05268 13.7598 1.14645 13.8536C1.24022 13.9473 1.36739 14 1.5 14H2.5C2.63261 14 2.75979 13.9473 2.85355 13.8536C2.94732 13.7598 3 13.6326 3 13.5V10.5C3 10.3674 2.94732 10.2402 2.85355 10.1464C2.75979 10.0527 2.63261 10 2.5 10H1.5ZM12.5 10C12.3674 10 12.2402 10.0527 12.1464 10.1464C12.0527 10.2402 12 10.3674 12 10.5V13.5C12 13.6326 12.0527 13.7598 12.1464 13.8536C12.2402 13.9473 12.3674 14 12.5 14H13.5C13.6326 14 13.7598 13.9473 13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5V10.5C14 10.3674 13.9473 10.2402 13.8536 10.1464C13.7598 10.0527 13.6326 10 13.5 10H12.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const InclusionIcon = createIcon({
  name: 'inclusion',
  transform: '',
  path: (
    <path
      d="M10.5 14.49v.5h.5v-.5h-.5zm-10 0H0v.5h.5v-.5zm7-4.996v.5-.5zm-4 0v-.5.5zM8 3.498a2.499 2.499 0 01-2.5 2.498v1C7.433 6.996 9 5.43 9 3.498H8zM5.5 5.996A2.499 2.499 0 013 3.498H2a3.499 3.499 0 003.5 3.498v-1zM3 3.498A2.499 2.499 0 015.5 1V0A3.499 3.499 0 002 3.498h1zM5.5 1A2.5 2.5 0 018 3.498h1A3.499 3.499 0 005.5 0v1zm5 12.99H.5v1h10v-1zm-9.5.5v-1.996H0v1.996h1zm2.5-4.496h4v-1h-4v1zm6.5 2.5v1.996h1v-1.997h-1zm-2.5-2.5a2.5 2.5 0 012.5 2.5h1a3.5 3.5 0 00-3.5-3.5v1zm-6.5 2.5a2.5 2.5 0 012.5-2.5v-1a3.5 3.5 0 00-3.5 3.5h1zM12 5v5h1V5h-1zm-2 3h5V7h-5v1z"
      fill="currentColor"
    />
  )
});

export const NotebookIcon = createIcon({
  name: 'notebook',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M13 1H2L2 3H13V1ZM2 0C1.44772 0 1 0.447715 1 1V3C1 3.55228 1.44772 4 2 4H13C13.5523 4 14 3.55228 14 3V1C14 0.447715 13.5523 0 13 0H2ZM13 6H2L2 9H13V6ZM2 5C1.44772 5 1 5.44772 1 6V9C1 9.55228 1.44772 10 2 10H13C13.5523 10 14 9.55228 14 9V6C14 5.44772 13.5523 5 13 5H2ZM2 12H13V14H2L2 12ZM1 12C1 11.4477 1.44772 11 2 11H13C13.5523 11 14 11.4477 14 12V14C14 14.5523 13.5523 15 13 15H2C1.44772 15 1 14.5523 1 14V12Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const ChartIcon = createIcon({
  name: 'chart',
  transform: '',
  path: (
    <path
      d="M0.5 14.5H0V15H0.5V14.5ZM6.5 5.5L6.9 5.2C6.85199 5.13605 6.78935 5.08455 6.71732 5.04981C6.64529 5.01508 6.56598 4.99813 6.48605 5.00038C6.40612 5.00263 6.32789 5.02403 6.25793 5.06276C6.18798 5.1015 6.12833 5.15645 6.084 5.223L6.5 5.5ZM9.5 9.5L9.1 9.8C9.14721 9.86287 9.20858 9.91373 9.27913 9.94844C9.34968 9.98314 9.42742 10.0007 9.50604 9.99975C9.58466 9.99878 9.66194 9.97928 9.7316 9.94283C9.80127 9.90639 9.86136 9.85403 9.907 9.79L9.5 9.5ZM0 0V14.5H1V0H0ZM0.5 15H15V14H0.5V15ZM2.916 11.777L6.916 5.777L6.084 5.223L2.084 11.223L2.916 11.777ZM6.1 5.8L9.1 9.8L9.9 9.2L6.9 5.2L6.1 5.8ZM9.907 9.79L14.907 2.79L14.093 2.21L9.093 9.21L9.907 9.79Z"
      fill="currentColor"
    />
  )
});

export const ViewLiveVersionIcon = createIcon({
  name: 'view-live-version',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M1 2H14V9H1V2ZM0 2C0 1.44772 0.447715 1 1 1H14C14.5523 1 15 1.44772 15 2V9C15 9.5523 14.5523 10 14 10H8V13H12V14H3V13H7V10H1C0.447715 10 0 9.5523 0 9V2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const KnowledgeIcon = createIcon({
  name: 'knowledge',
  transform: '',
  path: (
    <path
      d="M4.076 6.47L4.571 6.54L4.076 6.47ZM4.066 6.54L3.571 6.47L4.066 6.54ZM10.924 6.47L11.419 6.4L10.924 6.47ZM10.934 6.54L10.439 6.61L10.934 6.54ZM9.5 12.5V13C9.63261 13 9.75979 12.9473 9.85355 12.8536C9.94732 12.7598 10 12.6326 10 12.5H9.5ZM5.5 12.5H5C5 12.6326 5.05268 12.7598 5.14645 12.8536C5.24021 12.9473 5.36739 13 5.5 13V12.5ZM4.755 9.153L5.151 8.847L4.755 9.153ZM10.245 9.153L9.849 8.847L10.245 9.153ZM6 15H9V14H6V15ZM3.58 6.4L3.57 6.47L4.56 6.61L4.57 6.54L3.58 6.4ZM7.5 3C6.54674 2.99984 5.62543 3.34364 4.9053 3.96823C4.18518 4.59283 3.7146 5.45629 3.58 6.4L4.57 6.54C4.67087 5.83485 5.02272 5.18976 5.56095 4.72317C6.09919 4.25658 6.78768 3.9998 7.5 4V3ZM11.42 6.4C11.2854 5.45629 10.8148 4.59283 10.0947 3.96823C9.37457 3.34364 8.45326 2.99984 7.5 3V4C8.21227 4.00001 8.90064 4.25686 9.43883 4.72341C9.97703 5.18997 10.3289 5.83494 10.43 6.54L11.42 6.4ZM11.43 6.47L11.42 6.4L10.43 6.54L10.44 6.61L11.43 6.47ZM10.64 9.459C11.27 8.645 11.588 7.584 11.43 6.469L10.44 6.611C10.4973 7.00423 10.4745 7.40497 10.3731 7.7892C10.2718 8.17343 10.0938 8.53322 9.85 8.847L10.64 9.459ZM9 10.9V12.5H10V10.901H9V10.9ZM9.5 12H5.5V13H9.5V12ZM6 12.5V10.901H5V12.5H6ZM3.57 6.47C3.49398 6.99574 3.52477 7.53141 3.6605 8.04498C3.79624 8.55855 4.03415 9.03948 4.36 9.459L5.15 8.847C4.90617 8.53322 4.72823 8.17343 4.62685 7.7892C4.52547 7.40497 4.50273 7.00423 4.56 6.611L3.57 6.469V6.47ZM6 10.9C6 10.077 5.562 9.377 5.15 8.846L4.36 9.458C4.743 9.953 5 10.426 5 10.9H6ZM9.85 8.846C9.437 9.378 9 10.077 9 10.9H10C10 10.426 10.257 9.953 10.64 9.458L9.85 8.846ZM7 0V2H8V0H7ZM0 8H2V7H0V8ZM13 8H15V7H13V8ZM3.354 3.646L1.854 2.146L1.146 2.854L2.646 4.354L3.354 3.646ZM12.354 4.354L13.854 2.854L13.146 2.146L11.646 3.646L12.354 4.354Z"
      fill="currentColor"
    />
  )
});

export const AutoRunIcon = createIcon({
  name: 'auto-run',
  transform: '',
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M14 8c0-.35-.19-.64-.46-.82l-6-4A.969.969 0 0 0 7 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1 .21 0 .39-.08.54-.18l6-4c.27-.18.46-.47.46-.82Z"
        fill="currentColor"
        fillOpacity="0.4"
        strokeWidth="0"
      />
      <path
        clipRule="evenodd"
        d="M7 4.022v7.956L12.967 8 7 4.022Zm6.54 4.798-6.002 4.002a1.13 1.13 0 0 1-.27.134A.85.85 0 0 1 7 13c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1a.85.85 0 0 1 .268.044c.099.033.189.08.27.134L13.54 7.18c.27.18.46.47.46.82s-.19.64-.46.82ZM5 5.329 3.928 4.64 3 4.022v7.956l.938-.598L5 10.67v1.202l-.611.408-.69.446-.161.095a1.13 1.13 0 0 1-.27.134A.85.85 0 0 1 3 13c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1a.85.85 0 0 1 .268.044c.099.033.189.08.27.134l.002.002.147.09.702.449.611.408v1.202Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
});

export const HelpIcon = createIcon({
  name: 'help',
  transform: '',
  path: (
    <path
      d="M7.5 9V7.5H8C8.39782 7.5 8.77936 7.34196 9.06066 7.06066C9.34196 6.77936 9.5 6.39782 9.5 6V5.9C9.5 5.5287 9.3525 5.1726 9.08995 4.91005C8.8274 4.6475 8.4713 4.5 8.1 4.5H7.5C7.10218 4.5 6.72064 4.65804 6.43934 4.93934C6.15804 5.22064 6 5.60218 6 6M7 10.5H8M7.5 14.5C6.58075 14.5 5.6705 14.3189 4.82122 13.9672C3.97194 13.6154 3.20026 13.0998 2.55025 12.4497C1.90024 11.7997 1.38463 11.0281 1.03284 10.1788C0.68106 9.32951 0.5 8.41925 0.5 7.5C0.5 6.58075 0.68106 5.6705 1.03284 4.82122C1.38463 3.97194 1.90024 3.20026 2.55025 2.55025C3.20026 1.90024 3.97194 1.38463 4.82122 1.03284C5.6705 0.68106 6.58075 0.5 7.5 0.5C9.35652 0.5 11.137 1.2375 12.4497 2.55025C13.7625 3.86301 14.5 5.64348 14.5 7.5C14.5 9.35652 13.7625 11.137 12.4497 12.4497C11.137 13.7625 9.35652 14.5 7.5 14.5Z"
      stroke="currentColor"
    />
  )
});

export const PulseIcon = createIcon({
  name: 'pulse',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M5.82436 0.100098L7.67496 11.4251L10.1949 4.57123L12.4384 8.00353H15V8.95973H11.9366L10.4301 6.65484L7.5 15L5.42564 3.47639L3.12159 8.95973H0V8.00353H2.50341L5.82436 0.100098Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const CursorIcon = createIcon({
  name: 'cursor',
  transform: '',
  path: (
    <path
      d="M3 11V0L11 8L7.5 7.5L10 13L8 14L5.5 8.5L3 11Z"
      stroke="currentColor"
    />
  )
});

export const LearnIcon = createIcon({
  name: 'learn',
  transform: '',
  path: (
    <path
      d="M0.509073 0.5V0C0.374058 0 0.244574 0.0526784 0.149104 0.146447C0.0536343 0.240215 0 0.367392 0 0.5H0.509073ZM0.509073 13.5H0C0 13.6326 0.0536343 13.7598 0.149104 13.8536C0.244574 13.9473 0.374058 14 0.509073 14V13.5ZM3 0V15H4V0H3ZM0.509073 1H11.7087V0H0.509073V1ZM13.2359 2.5V11.5H14.254V2.5H13.2359ZM11.7087 13H0.509073V14H11.7087V13ZM1 13.5V0.5H0V13.5H1ZM13.2359 11.5C13.2359 11.8978 13.075 12.2794 12.7886 12.5607C12.5022 12.842 12.1137 13 11.7087 13V14C12.3837 14 13.0312 13.7366 13.5085 13.2678C13.9859 12.7989 14.254 12.163 14.254 11.5H13.2359ZM11.7087 1C12.1137 1 12.5022 1.15804 12.7886 1.43934C13.075 1.72064 13.2359 2.10218 13.2359 2.5H14.254C14.254 1.83696 13.9859 1.20107 13.5085 0.732233C13.0312 0.263392 12.3837 0 11.7087 0V1ZM6 5H11V4H6V5Z"
      fill="currentColor"
    />
  )
});

export const CategoriesAndStatusIcon = createIcon({
  name: 'categories-and-status',
  transform: '',
  path: (
    <path
      d="M12.5 14.5L12.188 14.89C12.2615 14.9487 12.3501 14.9855 12.4436 14.9961C12.5371 15.0067 12.6317 14.9907 12.7165 14.95C12.8013 14.9093 12.8729 14.8454 12.923 14.7658C12.9732 14.6862 12.9999 14.5941 13 14.5H12.5ZM12.5 0.5H13V0H12.5V0.5ZM2.5 0.5V0H2V0.5H2.5ZM2.5 14.5H2C2.00013 14.5941 2.02681 14.6862 2.07697 14.7658C2.12712 14.8454 2.19872 14.9093 2.28353 14.95C2.36834 14.9907 2.46292 15.0067 2.5564 14.9961C2.64989 14.9855 2.73848 14.9487 2.812 14.89L2.5 14.5ZM7.5 10.5L7.812 10.11C7.7234 10.0392 7.61338 10.0007 7.5 10.0007C7.38662 10.0007 7.2766 10.0392 7.188 10.11L7.5 10.5V10.5ZM13 14.5V0.5H12V14.5H13ZM2 0.5V14.5H3V0.5H2ZM2.812 14.89L7.812 10.89L7.188 10.11L2.188 14.11L2.812 14.89V14.89ZM7.188 10.89L12.188 14.89L12.812 14.11L7.812 10.11L7.188 10.89V10.89ZM12.5 0H2.5V1H12.5V0Z"
      fill="currentColor"
    />
  )
});

export const SearchIcon = createIcon({
  name: 'search',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M6.5 1C5.77773 1 5.06253 1.14226 4.39524 1.41866C3.72795 1.69506 3.12163 2.10019 2.61091 2.61091C2.10019 3.12163 1.69506 3.72795 1.41866 4.39524C1.14226 5.06253 1 5.77773 1 6.5C1 7.22227 1.14226 7.93747 1.41866 8.60476C1.69506 9.27205 2.10019 9.87836 2.61091 10.3891C3.12163 10.8998 3.72795 11.3049 4.39524 11.5813C5.06253 11.8577 5.77773 12 6.5 12C7.95869 12 9.35764 11.4205 10.3891 10.3891C11.4205 9.35764 12 7.95869 12 6.5C12 5.04131 11.4205 3.64236 10.3891 2.61091C9.35764 1.57946 7.95869 1 6.5 1ZM4.01256 0.494783C4.80117 0.168127 5.64641 0 6.5 0C8.22391 2.98023e-08 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.05646 12.4418 9.55537 11.4361 10.729L14.8536 14.1464L14.1464 14.8536L10.729 11.4361C9.55537 12.4418 8.05646 13 6.5 13C5.64641 13 4.80117 12.8319 4.01256 12.5052C3.22394 12.1786 2.50739 11.6998 1.90381 11.0962C1.30023 10.4926 0.821439 9.77606 0.494783 8.98744C0.168127 8.19883 0 7.35359 0 6.5C0 5.64641 0.168127 4.80117 0.494783 4.01256C0.821439 3.22394 1.30023 2.50739 1.90381 1.90381C2.50739 1.30023 3.22394 0.821439 4.01256 0.494783Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const InteractiveIcon = createIcon({
  name: 'interactive',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M7.5 1C6.2994 1 5.14971 1.47625 4.3034 2.32118C3.4574 3.16582 2.98377 4.30946 2.98377 5.5V9.5C2.98377 10.6905 3.4574 11.8342 4.3034 12.6788C5.14971 13.5238 6.2994 14 7.5 14C8.0943 14 8.68257 13.8831 9.23116 13.6563C9.77974 13.4294 10.2776 13.0971 10.6966 12.6788C11.1156 12.2605 11.4474 11.7644 11.6737 11.2191C11.8999 10.6738 12.0162 10.0897 12.0162 9.5V5.5C12.0162 4.30946 11.5426 3.16582 10.6966 2.32118C9.85029 1.47625 8.7006 1 7.5 1ZM3.61405 1.60775C4.64616 0.577319 6.04414 0 7.5 0C8.95586 0 10.3538 0.577319 11.3859 1.60775C12.4183 2.63848 13 4.03838 13 5.5V9.5C13 10.2235 12.8572 10.9398 12.5801 11.6077C12.303 12.2756 11.8971 12.8819 11.3859 13.3923C10.8748 13.9025 10.2685 14.3068 9.60188 14.5825C8.93525 14.8582 8.22106 15 7.5 15C6.04414 15 4.64616 14.4227 3.61405 13.3923C2.58165 12.3615 2 10.9616 2 9.5V5.5C2 4.03838 2.58165 2.63848 3.61405 1.60775ZM7.99189 4V7H7.00811V4H7.99189Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const AppBuilderIcon = createIcon({
  name: 'app-builder',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M5 1H1L1 14H5V1ZM1 0C0.447715 0 0 0.447715 0 1V14C0 14.5523 0.447715 15 1 15H5C5.55228 15 6 14.5523 6 14V1C6 0.447715 5.55228 0 5 0H1ZM14 1H8V7H14V1ZM8 0C7.44772 0 7 0.447715 7 1V7C7 7.55228 7.44772 8 8 8H14C14.5523 8 15 7.55228 15 7V1C15 0.447715 14.5523 0 14 0H8ZM8 10H14V14H8V10ZM7 10C7 9.44771 7.44772 9 8 9H14C14.5523 9 15 9.44772 15 10V14C15 14.5523 14.5523 15 14 15H8C7.44772 15 7 14.5523 7 14V10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const PublishIcon = createIcon({
  name: 'publish',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M3.56707 2.93736C4.18682 1.86471 5.30002 1 7 1C8.65813 1 9.79553 1.69861 10.5091 2.55491C11.0401 3.19205 11.3383 3.91863 11.4493 4.50475C11.9689 4.51998 12.6762 4.58383 13.3173 4.85096C13.7556 5.03359 14.1841 5.319 14.5012 5.76493C14.8205 6.21389 15 6.788 15 7.5C15 8.8537 14.5899 9.7576 13.9543 10.3138C13.3323 10.858 12.5726 11 12 11V10C12.4274 10 12.9177 9.892 13.2957 9.5612C13.6601 9.2424 14 8.6463 14 7.5C14 6.962 13.867 6.59861 13.6863 6.34445C13.5034 6.08724 13.2444 5.90391 12.9327 5.77404C12.2885 5.50565 11.5124 5.5 11 5.5H10.5V5C10.5 4.62492 10.2963 3.86154 9.74089 3.19509C9.20447 2.55139 8.34187 2 7 2C5.69998 2 4.89651 2.63529 4.43293 3.43764C3.95218 4.26971 3.84933 5.26709 3.98809 5.89153L4.08592 6.33174L3.65811 6.47434C3.47362 6.53584 3.03847 6.74908 2.65733 7.11207C2.28169 7.46982 2 7.93091 2 8.5C2 9.0491 2.26026 9.4012 2.64 9.6385C2.75186 9.70842 2.87345 9.76744 3 9.8162V10.8663C2.69511 10.7843 2.38901 10.6609 2.11 10.4865C1.48974 10.0988 1 9.4509 1 8.5C1 7.56909 1.46831 6.86351 1.96767 6.38793C2.29435 6.07681 2.65208 5.84602 2.94817 5.69497C2.87115 4.86517 3.05406 3.82527 3.56707 2.93736ZM7.5 6.793L7.854 7.146L10.854 10.146L10.146 10.854L8 8.708V14H7V8.708L4.854 10.854L4.146 10.146L7.146 7.146L7.5 6.793Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const CommentIcon = createIcon({
  name: 'comment',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M0 1.5C0 0.671572 0.671573 0 1.5 0H13.5C14.3284 0 15 0.671573 15 1.5V10.5C15 11.3284 14.3284 12 13.5 12H13V14.2826C13 14.7952 12.3987 15.0717 12.0095 14.7381L8.81504 12H1.5C0.671573 12 0 11.3284 0 10.5V1.5ZM1.5 1C1.22386 1 1 1.22386 1 1.5V10.5C1 10.7761 1.22386 11 1.5 11H9.18496L12 13.4129V11H13.5C13.7761 11 14 10.7761 14 10.5V1.5C14 1.22386 13.7761 1 13.5 1H1.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const CodeIcon = createIcon({
  name: 'code',
  transform: '',
  path: (
    <path
      d="M10.5039 9.728L10.1452 10.082L10.8636 10.789L11.2233 10.436L10.5039 9.728ZM13.912 7.082L14.2717 7.436L14.6304 7.082L14.2717 6.728L13.912 7.082ZM11.2233 3.728L10.8636 3.375L10.1452 4.082L10.5039 4.436L11.2233 3.728ZM4.40708 10.436L4.76679 10.789L5.48519 10.082L5.1265 9.728L4.40708 10.436ZM1.7184 7.082L1.35869 6.728L1 7.082L1.35869 7.436L1.7184 7.082ZM5.1265 4.436L5.48519 4.082L4.76679 3.375L4.40708 3.728L5.1265 4.436ZM11.2233 10.436L14.2717 7.436L13.5522 6.728L10.5039 9.728L11.2233 10.436ZM14.2717 6.728L11.2233 3.728L10.5039 4.436L13.5522 7.436L14.2717 6.728ZM5.1265 9.728L2.07811 6.728L1.35869 7.436L4.40708 10.436L5.1265 9.728ZM2.07811 7.436L5.1265 4.436L4.40708 3.728L1.35869 6.728L2.07811 7.436V7.436ZM8.33035 1L6.2981 13L7.3 13.164L9.33226 1.164L8.33035 1V1Z"
      fill="currentColor"
    />
  )
});

export const StarIcon = createIcon({
  name: 'star',
  transform: '',
  path: (
    <path
      d="M7.5 11.2514L3.483 13.3639L4.25 8.89007L1 5.72271L5.4915 5.06993L7.5 1L9.5085 5.06993L14 5.72271L10.75 8.89007L11.517 13.3639L7.5 11.2524V11.2514Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
});

export const VersioningIcon = createIcon({
  name: 'versioning',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M2.5 1C2.10218 1 1.72065 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5C1 2.89782 1.15804 3.27936 1.43934 3.56066C1.72065 3.84196 2.10218 4 2.5 4C2.89783 4 3.27936 3.84196 3.56066 3.56066C3.84197 3.27936 4 2.89782 4 2.5C4 2.10218 3.84197 1.72064 3.56066 1.43934C3.27936 1.15804 2.89783 1 2.5 1ZM0.732234 0.732233C1.20108 0.263392 1.83696 0 2.5 0C3.16304 0 3.79893 0.263392 4.26777 0.732233C4.73661 1.20107 5 1.83696 5 2.5C5 3.16304 4.73661 3.79893 4.26777 4.26777C3.91858 4.61696 3.47672 4.85218 3 4.9495V10.0505C3.47672 10.1478 3.91858 10.383 4.26777 10.7322C4.61696 11.0814 4.85218 11.5233 4.9495 12H9.5C10.163 12 10.7989 11.7366 11.2678 11.2678C11.7366 10.7989 12 10.163 12 9.5V7.9495C11.5233 7.85218 11.0814 7.61696 10.7322 7.26777C10.2634 6.79893 10 6.16304 10 5.5C10 4.83696 10.2634 4.20107 10.7322 3.73223C11.2011 3.26339 11.837 3 12.5 3C13.163 3 13.7989 3.26339 14.2678 3.73223C14.7366 4.20107 15 4.83696 15 5.5C15 6.16304 14.7366 6.79893 14.2678 7.26777C13.9186 7.61696 13.4767 7.85218 13 7.9495V9.5C13 10.4283 12.6313 11.3185 11.9749 11.9749C11.3185 12.6313 10.4283 13 9.5 13H4.94949C4.88499 13.316 4.75961 13.6181 4.57867 13.8889C4.30397 14.3 3.91353 14.6205 3.45671 14.8097C2.99989 14.9989 2.49723 15.0484 2.01228 14.952C1.52732 14.8555 1.08187 14.6174 0.732234 14.2678C0.382603 13.9181 0.144501 13.4727 0.0480379 12.9877C-0.0484251 12.5028 0.00108323 12.0001 0.190302 11.5433C0.379521 11.0865 0.699953 10.696 1.11108 10.4213C1.38187 10.2404 1.684 10.115 2 10.0505V4.9495C1.52328 4.85218 1.08143 4.61696 0.732234 4.26777C0.263393 3.79893 1.1273e-06 3.16304 1.1273e-06 2.5C1.1273e-06 1.83696 0.263393 1.20107 0.732234 0.732233ZM12.5 4C12.1022 4 11.7206 4.15804 11.4393 4.43934C11.158 4.72064 11 5.10218 11 5.5C11 5.89782 11.158 6.27936 11.4393 6.56066C11.7206 6.84196 12.1022 7 12.5 7C12.8978 7 13.2794 6.84196 13.5607 6.56066C13.842 6.27936 14 5.89782 14 5.5C14 5.10218 13.842 4.72064 13.5607 4.43934C13.2794 4.15804 12.8978 4 12.5 4ZM2.5 11C2.20333 11 1.91332 11.088 1.66665 11.2528C1.41997 11.4176 1.22771 11.6519 1.11418 11.926C1.00065 12.2001 0.970945 12.5017 1.02882 12.7926C1.0867 13.0836 1.22956 13.3509 1.43934 13.5607C1.64912 13.7704 1.91639 13.9133 2.20737 13.9712C2.49834 14.0291 2.79994 13.9994 3.07403 13.8858C3.34812 13.7723 3.58238 13.58 3.74721 13.3334C3.91203 13.0867 4 12.7967 4 12.5C4 12.1022 3.84197 11.7206 3.56066 11.4393C3.27936 11.158 2.89783 11 2.5 11Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const GreenTickIcon = createIcon({
  name: 'green-tick',
  transform: '',
  path: (
    <path
      d="M1 7L5.5 11.5L14 3"
      fill="none"
      stroke="#43D59D"
      strokeLinecap="square"
    />
  )
});

export const BabyStrollerIcon = createIcon({
  name: 'baby-stroller',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M2.10684 6C2.26205 5.19594 2.60124 4.20631 3.21923 3.32346C3.97116 2.24928 5.14479 1.3126 7 1.06427V6H2.10684ZM1 7C1 6.71862 1.02771 6.37786 1.09093 6C1.44902 3.85968 2.94637 0.528944 7 0.0564698C7.31743 0.0194713 7.65054 0 8 0V1V6H13V4V3.79289L13.1464 3.64645L14.1464 2.64645C14.3417 2.45118 14.6583 2.45118 14.8536 2.64645C15.0488 2.84171 15.0488 3.15829 14.8536 3.35355L14 4.20711V6V7V8C14 9.65685 12.6569 11 11 11H4C2.34315 11 1 9.65685 1 8V7ZM4 11C5.10457 11 6 11.8954 6 13C6 14.1046 5.10457 15 4 15C2.89543 15 2 14.1046 2 13C2 11.8954 2.89543 11 4 11ZM11 11C12.1046 11 13 11.8954 13 13C13 14.1046 12.1046 15 11 15C9.89543 15 9 14.1046 9 13C9 11.8954 9.89543 11 11 11ZM8 7H7H2V8C2 9.10457 2.89543 10 4 10H11C12.1046 10 13 9.10457 13 8V7H8ZM4 14C4.55228 14 5 13.5523 5 13C5 12.4477 4.55228 12 4 12C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14ZM11 14C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const LocationIcon = createIcon({
  name: 'location',
  transform: '',
  path: (
    <path
      d="M4.5 11.5H4C4 11.6326 4.05268 11.7598 4.14645 11.8536C4.24021 11.9473 4.36739 12 4.5 12V11.5ZM10.5 11.5V12C10.6326 12 10.7598 11.9473 10.8536 11.8536C10.9473 11.7598 11 11.6326 11 11.5H10.5ZM4.5 12H10.5V11H4.5V12ZM11 11.5V9.5H10V11.5H11ZM4 9.5V11.5H5V9.5H4ZM7.5 6C6.57174 6 5.6815 6.36875 5.02513 7.02513C4.36875 7.6815 4 8.57174 4 9.5H5C5 8.83696 5.26339 8.20107 5.73223 7.73223C6.20107 7.26339 6.83696 7 7.5 7V6ZM11 9.5C11 8.57174 10.6313 7.6815 9.97487 7.02513C9.3185 6.36875 8.42826 6 7.5 6V7C8.16304 7 8.79893 7.26339 9.26777 7.73223C9.73661 8.20107 10 8.83696 10 9.5H11ZM14 11.5C14 11.745 13.886 12.02 13.594 12.316C13.3 12.615 12.849 12.906 12.253 13.162C11.062 13.672 9.382 14 7.5 14V15C9.484 15 11.304 14.656 12.647 14.08C13.317 13.793 13.892 13.438 14.306 13.019C14.722 12.597 15 12.083 15 11.5H14ZM7.5 14C5.618 14 3.938 13.672 2.747 13.162C2.151 12.906 1.7 12.615 1.406 12.316C1.114 12.02 1 11.746 1 11.5H0C0 12.083 0.278 12.597 0.694 13.019C1.108 13.439 1.683 13.793 2.354 14.081C3.695 14.656 5.515 15 7.5 15V14ZM1 11.5C1 11.258 1.11 10.987 1.394 10.695C1.68 10.401 2.119 10.113 2.7 9.858L2.3 8.942C1.644 9.229 1.082 9.582 0.678 9.998C0.27 10.416 0 10.925 0 11.5H1ZM12.3 9.858C12.881 10.113 13.32 10.401 13.605 10.695C13.889 10.987 14 11.258 14 11.5H15C15 10.925 14.73 10.416 14.322 9.998C13.918 9.582 13.356 9.229 12.7 8.942L12.3 9.858V9.858ZM7.5 4C7.10218 4 6.72064 3.84196 6.43934 3.56066C6.15804 3.27936 6 2.89782 6 2.5H5C5 3.16304 5.26339 3.79893 5.73223 4.26777C6.20107 4.73661 6.83696 5 7.5 5V4ZM9 2.5C9 2.89782 8.84196 3.27936 8.56066 3.56066C8.27936 3.84196 7.89782 4 7.5 4V5C8.16304 5 8.79893 4.73661 9.26777 4.26777C9.73661 3.79893 10 3.16304 10 2.5H9ZM7.5 1C7.89782 1 8.27936 1.15804 8.56066 1.43934C8.84196 1.72064 9 2.10218 9 2.5H10C10 1.83696 9.73661 1.20107 9.26777 0.732233C8.79893 0.263392 8.16304 0 7.5 0V1ZM7.5 0C6.83696 0 6.20107 0.263392 5.73223 0.732233C5.26339 1.20107 5 1.83696 5 2.5H6C6 2.10218 6.15804 1.72064 6.43934 1.43934C6.72064 1.15804 7.10218 1 7.5 1V0Z"
      fill="currentColor"
    />
  )
});

export const DocIcon = createIcon({
  name: 'doc',
  transform: '',
  path: (
    <path
      d="M4.5 6.995H4V7.995H4.5V6.995ZM10.5 7.995H11V6.995H10.5V7.995ZM4.5 9.993H4V10.993H4.5V9.993ZM10.5 11H11V10H10.5V11ZM4.5 3.997H4V4.997H4.5V3.997ZM8.5 5H9V4H8.5V5ZM10.5 0.5L10.854 0.146L10.707 0H10.5V0.5ZM13.5 3.5H14V3.293L13.854 3.146L13.5 3.5V3.5ZM4.5 7.995H10.5V6.995H4.5V7.995ZM4.5 10.993L10.5 11V10L4.5 9.993V10.993ZM4.5 4.997L8.5 5V4L4.5 3.997V4.997ZM12.5 14H2.5V15H12.5V14ZM2 13.5V1.5H1V13.5H2ZM2.5 1H10.5V0H2.5V1ZM13 3.5V13.5H14V3.5H13ZM10.146 0.854L13.146 3.854L13.854 3.146L10.854 0.146L10.146 0.854V0.854ZM2.5 14C2.36739 14 2.24021 13.9473 2.14645 13.8536C2.05268 13.7598 2 13.6326 2 13.5H1C1 13.8978 1.15804 14.2794 1.43934 14.5607C1.72064 14.842 2.10218 15 2.5 15V14ZM12.5 15C12.8978 15 13.2794 14.842 13.5607 14.5607C13.842 14.2794 14 13.8978 14 13.5H13C13 13.6326 12.9473 13.7598 12.8536 13.8536C12.7598 13.9473 12.6326 14 12.5 14V15ZM2 1.5C2 1.36739 2.05268 1.24021 2.14645 1.14645C2.24021 1.05268 2.36739 1 2.5 1V0C2.10218 0 1.72064 0.158035 1.43934 0.43934C1.15804 0.720644 1 1.10218 1 1.5H2Z"
      fill="currentColor"
    />
  )
});

export const AsteriskIcon = createIcon({
  name: 'asterisk',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M8 0H7V6.29333L2.69263 1.98596L1.98552 2.69307L6.29245 7H0V8H6.29276L1.97893 12.3138L2.68604 13.0209L7 8.70697V15H8V8.70755L12.3066 13.0141L13.0137 12.307L8.70667 8H15V7H8.70697L13.0208 2.68616L12.3137 1.97905L8 6.29276V0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const InUseIcon = createIcon({
  name: 'in-use',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M9.80507 3.0002C10.8708 2.99474 11.8701 3.40542 12.6255 4.16015C13.3831 4.9168 13.8002 5.9252 13.8 7.0001C13.8 8.07472 13.3828 9.08326 12.6253 9.83991C11.8756 10.5888 10.8839 11 9.82947 11L9.79639 10.9999C9.55116 10.9978 9.35392 10.7959 9.35595 10.549C9.35798 10.3021 9.55563 10.1029 9.80357 10.1055L9.8292 10.1056C10.6481 10.1056 11.418 9.78625 11.9999 9.20478C12.588 8.61729 12.912 7.83402 12.912 6.99983C12.912 6.16563 12.5881 5.38263 12.0001 4.79501C11.418 4.21353 10.648 3.89419 9.8292 3.89419C9.82529 3.89419 9.82142 3.89424 9.81753 3.89428C9.8117 3.89434 9.80585 3.89441 9.79991 3.89433L9.79815 3.89419L9.79639 3.89433C8.97164 3.89119 8.18782 4.20739 7.59989 4.79501C7.01183 5.3825 6.68797 6.16563 6.68797 6.99983C6.68797 7.24667 6.48924 7.44696 6.24401 7.44696C5.99878 7.44696 5.80005 7.24667 5.80005 6.99983C5.80005 5.92534 6.21731 4.91693 6.97469 4.16015C7.73017 3.40542 8.73061 2.99569 9.79517 3.0002L9.79652 3.00006C9.79734 2.99997 9.79815 3 9.79896 3.00003C9.79937 3.00005 9.79978 3.00006 9.80018 3.00006C9.80099 3.00015 9.80174 3.00012 9.80251 3.00009C9.8029 3.00008 9.8033 3.00006 9.80371 3.00006L9.80507 3.0002ZM8.11235 7.00011C8.11235 6.75326 8.31121 6.55297 8.55631 6.55297C8.8014 6.55297 9.00027 6.75312 9 6.99998C9 8.0745 8.58288 9.08307 7.82536 9.83974C7.07585 10.5886 6.08381 11 5.02928 11L5 10.9999L4.97072 11C3.91605 11 2.92415 10.5888 2.1745 9.83974C1.41712 9.08307 1 8.0745 1 6.99998C1 5.92546 1.41726 4.91702 2.17464 4.16022C2.93202 3.40355 3.93232 2.99299 5.00366 3.00009C5.24889 3.00214 5.44613 3.20394 5.4441 3.45092C5.44206 3.69791 5.2371 3.89507 4.99648 3.89452C4.17145 3.89111 3.38818 4.20759 2.79998 4.79523C2.21192 5.38274 1.88806 6.16589 1.88806 7.00011C1.88806 7.83447 2.21192 8.61749 2.79998 9.20499C3.38818 9.7925 4.16576 10.118 5.0038 10.1058L5.02928 10.106C5.84821 10.106 6.61833 9.78649 7.20043 9.20499C7.78849 8.61749 8.11235 7.83447 8.11235 7.00011Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const PlusIcon = createIcon({
  name: 'plus',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M9.5 8V14H8.5V8H2.5V7H8.5V1H9.5V7H15.5V8H9.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const OutlineIcon = createIcon({
  name: 'outline',
  transform: '',
  path: (
    <>
      <path
        d="M1 5C1 4.44772 1.44772 4 2 4H13C13.5523 4 14 4.44772 14 5V8C14 8.55228 13.5523 9 13 9H2C1.44772 9 1 8.55228 1 8V5Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path
        clipRule="evenodd"
        d="M13 5H2L2 8H13V5ZM2 4C1.44772 4 1 4.44772 1 5V8C1 8.55228 1.44772 9 2 9H13C13.5523 9 14 8.55228 14 8V5C14 4.44772 13.5523 4 13 4H2Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M1 1.5C1 1.22386 1.22386 1 1.5 1H13.5C13.7761 1 14 1.22386 14 1.5C14 1.77614 13.7761 2 13.5 2H1.5C1.22386 2 1 1.77614 1 1.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5ZM1.5 13C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14H13.5C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13H1.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
});

export const DataSourcesIcon = createIcon({
  name: 'data-sources',
  transform: '',
  path: (
    <>
      <path
        d="M11 2.5L5.5 9.5H9.5L9 12.5L14 6.5H10.5L11 2.5Z"
        fill="currentColor"
        opacity="0.2"
      />
      <path
        clipRule="evenodd"
        d="M2.14914 0.609383L2.19234 0.595681C3.37179 0.221591 4.07044 0 7 0C8.04628 0 9.01165 0.0642082 9.8677 0.181908L9.19429 1.10785C8.52823 1.03836 7.79287 1 7 1C4.21744 1 3.57924 1.20334 2.58084 1.52143L2.45136 1.56262C1.90997 1.73427 1.52165 1.92749 1.2791 2.1163C1.03316 2.30775 1 2.44121 1 2.5C1 2.55791 1.03273 2.69091 1.2788 2.88216C1.52136 3.07068 1.90973 3.26364 2.45118 3.43507L2.58077 3.47624C3.57918 3.7939 4.21751 3.997 7 3.997L7.09322 3.99682L6.36859 4.99318C3.96155 4.96242 3.28225 4.74726 2.19282 4.4022L2.14932 4.38843C1.71286 4.25024 1.32321 4.08702 1 3.89705V7.496C1 7.55479 1.03316 7.68825 1.2791 7.8797C1.52165 8.06851 1.90997 8.26173 2.45136 8.43338L2.58084 8.47457L2.58085 8.47457C2.93657 8.5879 3.24656 8.68667 3.6241 8.76686L2.98878 9.64043C2.72618 9.56964 2.47286 9.48929 2.19234 9.40032L2.14914 9.38662C1.71276 9.24826 1.32318 9.08485 1 8.89466V12.492C1 12.5507 1.03312 12.6841 1.27903 12.8755C1.52155 13.0642 1.90987 13.2573 2.45127 13.4289L2.58047 13.4699C3.47562 13.7549 4.08109 13.9477 6.20154 13.9846L6.10171 14.9829C3.90892 14.9399 3.24056 14.728 2.19209 14.3957L2.14923 14.3821C1.54888 14.1919 1.03707 13.9543 0.66491 13.6647C0.296134 13.3777 0 12.9853 0 12.492V2.5C0 2.00679 0.296094 1.61425 0.664835 1.3272C1.03698 1.03751 1.54878 0.79973 2.14914 0.609383ZM4 10L12 0L11 6H15L8 15L9 10H4ZM9.81954 7H12.9194L9.61759 11.3772L10.1805 9H6.08062L10.3824 3.62277L9.81954 7Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
});

export const PackagesIcon = createIcon({
  name: 'packages',
  transform: '',
  path: (
    <>
      <path d="M14 3L7 6V14L14 11V3Z" fill="currentColor" opacity="0.2" />
      <path
        clipRule="evenodd"
        d="M7.30315 0.0403799C7.42886 -0.01346 7.57114 -0.01346 7.69685 0.0403799L14.6968 2.5823C14.8807 2.66107 15 2.84186 15 3.04192V11.0439C15 11.2439 14.8808 11.4247 14.697 11.5035L7.69696 14.5035C7.57119 14.5574 7.42881 14.5574 7.30304 14.5035L0.30304 11.5035C0.119198 11.4247 0 11.2439 0 11.0439V3.04192C0 2.84186 0.11925 2.66107 0.303151 2.5823L7.30315 0.0403799ZM7 6.04392L1 3.80179V10.7142L7 13.2857V6.04392ZM8 13.2857L14 10.7142V3.80039L8 6.04766V13.2857ZM13.23 3.04192L7.5 1.04393L1.77001 3.04192L7.5 5.17012L13.23 3.04192Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
});

export const FilesIcon = createIcon({
  name: 'files',
  transform: '',
  path: (
    <>
      <path d="M13.5 7H1.5V13H13.5V7Z" fill="currentColor" opacity="0.2" />
      <path
        clipRule="evenodd"
        d="M2.5 3C2.36739 3 2.24021 3.05268 2.14645 3.14645C2.05268 3.24021 2 3.36739 2 3.5V12.5C2 12.6326 2.05268 12.7598 2.14645 12.8536C2.24022 12.9473 2.36739 13 2.5 13H12.5C12.6326 13 12.7598 12.9473 12.8536 12.8536C12.9473 12.7598 13 12.6326 13 12.5V5.5C13 5.36739 12.9473 5.24021 12.8536 5.14645C12.7598 5.05268 12.6326 5 12.5 5H8.29289L6.29289 3H2.5ZM1.43934 2.43934C1.72064 2.15804 2.10218 2 2.5 2H6.70711L8.70711 4H12.5C12.8978 4 13.2794 4.15804 13.5607 4.43934C13.842 4.72064 14 5.10217 14 5.5V12.5C14 12.8978 13.842 13.2794 13.5607 13.5607C13.2794 13.842 12.8978 14 12.5 14H2.5C2.10217 14 1.72064 13.842 1.43934 13.5607C1.15804 13.2794 1 12.8978 1 12.5V3.5C1 3.10218 1.15804 2.72064 1.43934 2.43934Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <rect fill="currentColor" height="1" width="11" x="2" y="7" />
    </>
  )
});

export const VariablesIcon = createIcon({
  name: 'variables',
  transform: '',
  path: (
    <>
      <path
        d="M4.5 10.5L6.59025 7.45349L4.64079 4.5H6.47112L7.06679 5.46512L7.52166 6.24419H7.6083L8.07401 5.46512L8.68051 4.5H10.3592L8.40975 7.36047L10.5 10.5H8.65884L7.95487 9.37209L7.46751 8.56977H7.38087L6.90433 9.37209L6.18953 10.5H4.5Z"
        fill="currentColor"
      />
      <path
        clipRule="evenodd"
        d="M2 1H1V14H2H5V13H2V2H5V1H2ZM13 1H10V2H13V13H10V14H13H14V1H13Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
});

export const HistoryIcon = createIcon({
  name: 'history',
  transform: '',
  path: (
    <>
      <path
        d="M2.5 12.399L2.87 12.063L2.864 12.056L2.857 12.049L2.5 12.399ZM3.5 13.5V14H4V13.5H3.5ZM7 14.482L7.018 13.982L6.965 14.982L7 14.482ZM7.5 7.5H7C6.99988 7.5657 7.01272 7.63079 7.03777 7.69153C7.06282 7.75227 7.0996 7.80748 7.146 7.854L7.5 7.5ZM14 7.5C14 8.35359 13.8319 9.19883 13.5052 9.98744C13.1786 10.7761 12.6998 11.4926 12.0962 12.0962C11.4926 12.6998 10.7761 13.1786 9.98744 13.5052C9.19883 13.8319 8.35359 14 7.5 14V15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5H14ZM7.5 1C8.35359 1 9.19883 1.16813 9.98744 1.49478C10.7761 1.82144 11.4926 2.30023 12.0962 2.90381C12.6998 3.50739 13.1786 4.22394 13.5052 5.01256C13.8319 5.80117 14 6.64641 14 7.5H15C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0V1ZM7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5H1C1 5.77609 1.68482 4.12279 2.90381 2.90381C4.12279 1.68482 5.77609 1 7.5 1V0ZM2.857 12.049C1.66456 10.8354 0.997508 9.20138 1 7.5H0C0 9.543 0.818 11.397 2.143 12.749L2.857 12.049V12.049ZM2.13 12.735L3.13 13.836L3.87 13.164L2.87 12.063L2.13 12.735V12.735ZM7.5 14C7.34486 14.0001 7.18976 13.9948 7.035 13.984L6.965 14.981C7.142 14.994 7.32 15 7.5 15V14ZM7.518 14L7.018 13.983L6.982 14.983L7.482 15L7.518 14ZM7 3V7.5H8V3H7ZM7.146 7.854L10.146 10.854L10.854 10.146L7.854 7.146L7.146 7.854V7.854ZM0 14H3.5V13H0V14ZM4 13.5V10H3V13.5H4Z"
        fill="currentColor"
      />
      <path
        clipRule="evenodd"
        d="M13.3195 11.3914C14.0651 10.2786 14.5 8.94009 14.5 7.5C14.5 3.63401 11.366 0.5 7.5 0.5C3.63401 0.5 0.5 3.63401 0.5 7.5C0.5 7.64843 0.50462 7.79579 0.513724 7.94193C1.76969 6.06737 3.90737 4.83334 6.33327 4.83334C10.0508 4.83334 13.0915 7.73132 13.3195 11.3914Z"
        fill="currentColor"
        fillRule="evenodd"
        opacity="0.2"
      />
    </>
  )
});

export const ScheduledRunsIcon = createIcon({
  name: 'scheduled-runs',
  transform: '',
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M12.1731 12.2636C11.642 12.4175 11.0806 12.5 10.5 12.5C7.18629 12.5 4.5 9.81368 4.5 6.49997C4.5 5.07476 4.99691 3.76561 5.82694 2.73633C3.32736 3.46064 1.5 5.7669 1.5 8.49997C1.5 11.8137 4.18629 14.5 7.5 14.5C9.3885 14.5 11.0732 13.6275 12.1731 12.2636Z"
        fill="currentColor"
        fillRule="evenodd"
        opacity="0.2"
      />
      <path
        clipRule="evenodd"
        d="M9 1H6V0H9V1ZM2.90381 3.90381C4.12279 2.68482 5.77609 2 7.5 2C9.22391 2 10.8772 2.68482 12.0962 3.90381C13.3152 5.12279 14 6.77609 14 8.5C14 10.2239 13.3152 11.8772 12.0962 13.0962C10.8772 14.3152 9.22391 15 7.5 15C5.77609 15 4.12279 14.3152 2.90381 13.0962C1.68482 11.8772 1 10.2239 1 8.5C1 6.77609 1.68482 5.12279 2.90381 3.90381ZM7.5 3C6.04131 3 4.64236 3.57946 3.61091 4.61091C2.57946 5.64236 2 7.04131 2 8.5C2 9.95869 2.57946 11.3576 3.61091 12.3891C4.64236 13.4205 6.04131 14 7.5 14C8.95869 14 10.3576 13.4205 11.3891 12.3891C12.4205 11.3576 13 9.95869 13 8.5C13 7.04131 12.4205 5.64236 11.3891 4.61091C10.3576 3.57946 8.95869 3 7.5 3ZM7 5H8V8H10V9H7V5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
});

export const NotificationsIcon = createIcon({
  name: 'notifications',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M7.5 1C6.30653 1 5.16193 1.47411 4.31802 2.31802C3.47411 3.16193 3 4.30653 3 5.5V10H12V5.5C12 4.30653 11.5259 3.16193 10.682 2.31802C9.83807 1.47411 8.69347 1 7.5 1ZM13 10V5.5C13 4.04131 12.4205 2.64236 11.3891 1.61091C10.3576 0.579463 8.95869 0 7.5 0C6.04131 0 4.64236 0.579463 3.61091 1.61091C2.57946 2.64236 2 4.04131 2 5.5V10H1V11H14V10H13ZM5 12.5V12H6V12.5C6 12.8978 6.15804 13.2794 6.43934 13.5607C6.72064 13.842 7.10218 14 7.5 14C7.89782 14 8.27936 13.842 8.56066 13.5607C8.84196 13.2794 9 12.8978 9 12.5V12H10V12.5C10 13.163 9.73661 13.7989 9.26777 14.2678C8.79893 14.7366 8.16304 15 7.5 15C6.83696 15 6.20107 14.7366 5.73223 14.2678C5.26339 13.7989 5 13.163 5 12.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const LockIcon = createIcon({
  name: 'lock',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M7.5 1C5.94278 1 5 2.15622 5 3.5V5H10V3.5C10 2.15622 9.05722 1 7.5 1ZM11 5V3.5C11 1.53007 9.53263 0 7.5 0C5.46737 0 4 1.53007 4 3.5V5H2.58333C1.74732 5 1 5.63464 1 6.5V13.5C1 14.3654 1.74732 15 2.58333 15H12.4167C13.2527 15 14 14.3654 14 13.5V6.5C14 5.63464 13.2527 5 12.4167 5H11ZM2.58333 6C2.22273 6 2 6.26079 2 6.5V13.5C2 13.7392 2.22273 14 2.58333 14H12.4167C12.7773 14 13 13.7392 13 13.5V6.5C13 6.26079 12.7773 6 12.4167 6H2.58333Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const SaveIcon = createIcon({
  name: 'save',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M2.5 2C2.36739 2 2.24021 2.05268 2.14645 2.14645C2.05268 2.24021 2 2.36739 2 2.5V12.5C2 12.6326 2.05268 12.7598 2.14645 12.8536C2.24022 12.9473 2.36739 13 2.5 13H4V9.5C4 9.1022 4.15804 8.72064 4.43934 8.43934C4.72064 8.15804 5.10217 8 5.5 8H9.5C9.89783 8 10.2794 8.15804 10.5607 8.43934C10.842 8.72064 11 9.1022 11 9.5V13H12.5C12.6326 13 12.7598 12.9473 12.8536 12.8536C12.9473 12.7598 13 12.6326 13 12.5V5.0135L12.7832 4.49026L10.5097 2.21685L9.9865 2H2.5ZM12.5 14C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5V4.8145L13.6308 3.92374L11.0763 1.36915L10.1855 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V12.5C1 12.8978 1.15804 13.2794 1.43934 13.5607C1.72064 13.842 2.10218 14 2.5 14H12.5ZM10 13V9.5C10 9.3674 9.94732 9.2402 9.85355 9.1464C9.75978 9.0527 9.63261 9 9.5 9H5.5C5.36739 9 5.24022 9.0527 5.14645 9.1464C5.05268 9.2402 5 9.3674 5 9.5V13H10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const EditIcon = createIcon({
  name: 'edit',
  transform: '',
  path: (
    <path
      d="M.5 9.5l-.354-.354L0 9.293V9.5h.5zm9-9l.354-.354a.5.5 0 00-.708 0L9.5.5zm5 5l.354.354a.5.5 0 000-.708L14.5 5.5zm-9 9v.5h.207l.147-.146L5.5 14.5zm-5 0H0a.5.5 0 00.5.5v-.5zm.354-4.646l9-9-.708-.708-9 9 .708.708zm8.292-9l5 5 .708-.708-5-5-.708.708zm5 4.292l-9 9 .708.708 9-9-.708-.708zM5.5 14h-5v1h5v-1zm-4.5.5v-5H0v5h1zM6.146 3.854l5 5 .708-.708-5-5-.708.708zM8 15h7v-1H8v1z"
      fill="currentColor"></path>
  )
});

export const ChevronDown = createIcon({
  name: 'chevron-down',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M4.50001 5.79289L7.50001 8.79289L10.5 5.79289L11.2071 6.5L7.50001 10.2071L3.79291 6.5L4.50001 5.79289Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const SmallTickIcon = createIcon({
  name: 'small-tick',
  transform: '',
  path: <path d="M4 7.5L7 10l4-5" stroke="currentColor" />
});

export const OutputArrowIcon = createIcon({
  name: 'output-arrow',
  transform: '',
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M11.3796 3.67459L14.6585 7.49999L11.3796 11.3254L10.6204 10.6746L12.9129 7.99999H2V6.99999H12.9129L10.6204 4.32538L11.3796 3.67459Z"
        fill="currentColor"
        fillRule="evenodd"></path>
      <path d="M1 1H2V8H1V1Z" fill="currentColor"></path>
    </>
  )
});

export const ChargeIcon = createIcon({
  name: 'charge',
  transform: '',
  path: (
    <path
      d="M12.5 11.5H12H12.5ZM11.5 12.5V13V12.5ZM11.5 2.5V2V2.5ZM12.5 3.5H13H12.5ZM0.5 3.5H0H0.5ZM1.5 2.5V3V2.5ZM0.5 11.5H1H0.5ZM1.5 12.5V12V12.5ZM6.5 9.5L6.276 9.947C6.35223 9.9852 6.43696 10.0033 6.52214 9.99949C6.60732 9.99572 6.69012 9.97022 6.76267 9.92543C6.83522 9.88064 6.89511 9.81803 6.93665 9.74357C6.97819 9.66911 7 9.58526 7 9.5H6.5ZM6.5 5.5L6.724 5.053C6.64777 5.0148 6.56304 4.99673 6.47786 5.00051C6.39268 5.00428 6.30988 5.02978 6.23733 5.07457C6.16478 5.11936 6.10489 5.18197 6.06335 5.25643C6.02181 5.33089 6 5.41474 6 5.5H6.5ZM1 11.5V3.5H0V11.5H1ZM1.5 3H11.5V2H1.5V3ZM12 3.5V11.5H13V3.5H12ZM11.5 12H1.5V13H11.5V12ZM12 11.5C12 11.6326 11.9473 11.7598 11.8536 11.8536C11.7598 11.9473 11.6326 12 11.5 12V13C11.8978 13 12.2794 12.842 12.5607 12.5607C12.842 12.2794 13 11.8978 13 11.5H12ZM11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24021 12 3.36739 12 3.5H13C13 3.10218 12.842 2.72064 12.5607 2.43934C12.2794 2.15804 11.8978 2 11.5 2V3ZM1 3.5C1 3.36739 1.05268 3.24021 1.14645 3.14645C1.24021 3.05268 1.36739 3 1.5 3V2C1.10218 2 0.720644 2.15804 0.43934 2.43934C0.158035 2.72064 0 3.10218 0 3.5H1ZM0 11.5C0 11.8978 0.158035 12.2794 0.43934 12.5607C0.720644 12.842 1.10218 13 1.5 13V12C1.36739 12 1.24021 11.9473 1.14645 11.8536C1.05268 11.7598 1 11.6326 1 11.5H0ZM15 10V5H14V10H15ZM2.276 7.947L6.276 9.947L6.724 9.053L2.724 7.053L2.276 7.947V7.947ZM7 9.5V5.5H6V9.5H7ZM6.276 5.947L10.276 7.947L10.724 7.053L6.724 5.053L6.276 5.947Z"
      fill="currentColor"
    />
  )
});

export const PlayIcon = createIcon({
  name: 'play',
  transform: '',
  path: (
    <path d="M5 13V3L12 8L5 13Z" stroke="currentColor" strokeLinejoin="round" />
  )
});

export const CloseIcon = createIcon({
  name: 'close',
  transform: '',
  path: (
    <>
      <path d="M0.5 0.5L15.5 15.5" stroke="currentColor" />
      <path d="M0.5 15.5L15.5 0.5" stroke="currentColor" />
    </>
  )
});

export const InfoIcon = createIcon({
  name: 'info',
  transform: '',
  path: (
    <path
      d="M7 4.5V5h1v-.5H7zm1-.01v-.5H7v.5h1zM8 11V7H7v4h1zm0-6.5v-.01H7v.01h1zM6 8h1.5V7H6v1zm0 3h3v-1H6v1zM7.5 1A6.5 6.5 0 0114 7.5h1A7.5 7.5 0 007.5 0v1zM1 7.5A6.5 6.5 0 017.5 1V0A7.5 7.5 0 000 7.5h1zM7.5 14A6.5 6.5 0 011 7.5H0A7.5 7.5 0 007.5 15v-1zm0 1A7.5 7.5 0 0015 7.5h-1A6.5 6.5 0 017.5 14v1z"
      fill="currentColor"></path>
  )
});

export const TwitterIcon = createIcon({
  name: 'twitter',
  transform: '',
  path: (
    <path
      d="M13.4644 3.98737C13.4735 4.11756 13.4735 4.24775 13.4735 4.37914C13.4735 8.38269 10.3778 13 4.71725 13V12.9976C3.04509 13 1.40768 12.5284 0 11.6393C0.243144 11.6681 0.487508 11.6825 0.73248 11.6831C2.11822 11.6843 3.46435 11.2265 4.55454 10.3836C3.23766 10.359 2.08288 9.51362 1.67946 8.2795C2.14077 8.36709 2.61609 8.34909 3.06886 8.2273C1.63315 7.94172 0.600244 6.6998 0.600244 5.25749V5.21909C1.02803 5.45368 1.50701 5.58387 1.99695 5.59827C0.644729 4.70852 0.22791 2.93744 1.04449 1.55272C2.60695 3.4456 4.91225 4.59633 7.38696 4.71812C7.13894 3.66579 7.47776 2.56306 8.27727 1.82331C9.51676 0.676178 11.4662 0.734974 12.6313 1.9547C13.3205 1.82091 13.9811 1.57192 14.5856 1.21914C14.3559 1.9205 13.8751 2.51626 13.2328 2.89484C13.8428 2.82404 14.4388 2.66325 15 2.41787C14.5868 3.02743 14.0664 3.5584 13.4644 3.98737Z"
      fill="currentColor"
    />
  )
});

export const LinkedInIcon = createIcon({
  name: 'linkedin',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M13.0393 1.00006H1.96055C1.83583 0.998632 1.71205 1.02178 1.59627 1.06819C1.4805 1.1146 1.375 1.18336 1.28581 1.27055C1.19661 1.35773 1.12546 1.46163 1.07642 1.57632C1.02738 1.691 1.00141 1.81422 1 1.93894V13.0611C1.00141 13.1858 1.02738 13.309 1.07642 13.4237C1.12546 13.5384 1.19661 13.6423 1.28581 13.7295C1.375 13.8166 1.4805 13.8854 1.59627 13.9318C1.71205 13.9782 1.83583 14.0014 1.96055 13.9999H13.0393C13.164 14.0014 13.2878 13.9782 13.4036 13.9318C13.5194 13.8854 13.6249 13.8166 13.7141 13.7295C13.8033 13.6423 13.8744 13.5384 13.9235 13.4237C13.9725 13.309 13.9985 13.1858 13.9999 13.0611V1.93894C13.9985 1.81422 13.9725 1.691 13.9235 1.57632C13.8744 1.46163 13.8033 1.35773 13.7141 1.27055C13.6249 1.18336 13.5194 1.1146 13.4036 1.06819C13.2878 1.02178 13.164 0.998632 13.0393 1.00006ZM2.9281 5.87467H4.85642V12.0785H2.9281V5.87467ZM3.89587 2.80525C4.11727 2.80525 4.3337 2.87091 4.51779 2.99391C4.70188 3.11692 4.84536 3.29175 4.93009 3.4963C5.01482 3.70085 5.03699 3.92593 4.9938 4.14308C4.9506 4.36023 4.84399 4.55969 4.68743 4.71625C4.53087 4.8728 4.33141 4.97942 4.11426 5.02261C3.89711 5.0658 3.67203 5.04364 3.46748 4.95891C3.26293 4.87418 3.0881 4.7307 2.96509 4.54661C2.84209 4.36252 2.77644 4.14609 2.77644 3.92469C2.77644 3.62779 2.89438 3.34306 3.10431 3.13313C3.31425 2.92319 3.59898 2.80525 3.89587 2.80525ZM7.91884 5.87486H6.06996V12.0751H7.99106V9.00566C7.99106 8.19678 8.14272 7.41317 9.1466 7.41317C10.1505 7.41317 10.1505 8.33761 10.1505 9.05982V12.0787H12.0788V8.67705C12.0788 7.00873 11.7213 5.72319 9.76771 5.72319C9.40171 5.7095 9.03886 5.79529 8.71774 5.97143C8.39663 6.14756 8.12927 6.40746 7.94411 6.72346H7.91884V5.87486Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const PinIcon = createIcon({
  iconSize: 12,
  name: 'pin',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M9.75 4.42105C9.75 5.41539 9.20987 6.68242 8.34538 8.00536C7.65257 9.06557 6.79951 10.0897 6 10.9304C5.20049 10.0897 4.34743 9.06557 3.65462 8.00536C2.79013 6.68242 2.25 5.41539 2.25 4.42105C2.25 2.40605 3.91636 0.75 6 0.75C8.08364 0.75 9.75 2.40605 9.75 4.42105ZM10.5 4.42105C10.5 6.86273 7.92857 10.1053 6 12C4.07143 10.1053 1.5 6.86273 1.5 4.42105C1.5 1.97937 3.51472 0 6 0C8.48528 0 10.5 1.97937 10.5 4.42105ZM6 5.89482C6.82843 5.89482 7.5 5.23503 7.5 4.42113C7.5 3.60724 6.82843 2.94745 6 2.94745C5.17157 2.94745 4.5 3.60724 4.5 4.42113C4.5 5.23503 5.17157 5.89482 6 5.89482Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const CalendarIcon = createIcon({
  iconSize: 12,
  name: 'pin',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M2.25,0v1.5H1.12c-0.3,0-0.58,0.12-0.8,0.33C0.12,2.04,0,2.33,0,2.62v8.25c0,0.3,0.12,0.58,0.33,0.8
      C0.54,11.88,0.83,12,1.12,12h9.75c0.3,0,0.58-0.12,0.8-0.33c0.21-0.21,0.33-0.5,0.33-0.8V2.62c0-0.3-0.12-0.58-0.33-0.8
      c-0.21-0.21-0.5-0.33-0.8-0.33H9.75V0H9v1.5H3V0H2.25z M1.12,2.25h1.12v1.5H3v-1.5h6v1.5h0.75v-1.5h1.12c0.1,0,0.19,0.04,0.27,0.11
      c0.07,0.07,0.11,0.17,0.11,0.27v2.62H0.75V2.62c0-0.1,0.04-0.19,0.11-0.27C0.93,2.29,1.03,2.25,1.12,2.25z M0.75,6v4.88
      c0,0.1,0.04,0.19,0.11,0.27c0.07,0.07,0.17,0.11,0.27,0.11h9.75c0.1,0,0.19-0.04,0.27-0.11c0.07-0.07,0.11-0.17,0.11-0.27V6H0.75z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const BugIcon = createIcon({
  name: 'bug',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M8.5 2C7.83696 2 7.20107 2.26339 6.73223 2.73223C6.26339 3.20107 6 3.83696 6 4.5V5H11V4.5C11 3.83696 10.7366 3.20107 10.2678 2.73223C9.79893 2.26339 9.16304 2 8.5 2ZM11.1912 6H5.80883L5.58025 6.45653C5.19868 7.22011 4.99992 8.06234 5 8.91595V11.5C5 12.4283 5.36875 12.3185 6.02513 12.9749C6.6815 13.6313 7.57174 14 8.5 14C9.42826 14 10.3185 13.6313 10.9749 12.9749C11.4497 12.5 12 12 12 11.5V8.916C12.0001 8.06239 11.8015 7.22043 11.4199 6.45685L11.1912 6ZM5 4.94098V4.5C5 3.57174 5.36875 2.6815 6.02513 2.02513C6.6815 1.36875 7.57174 1 8.5 1C9.42826 1 10.3185 1.36875 10.9749 2.02513C11.6313 2.6815 12 3.57174 12 4.5V4.94098L14.7764 3.55279L15.2236 4.44721L12.2712 5.92343L12.3141 6.00915C12.7652 6.91164 13.0001 7.90706 13 8.916V9H16V10H13V11.5C13 11.5 13 12 12.6409 12.2614L15.2236 13.5528L14.7764 14.4472L12.149 13.1335C12.0091 13.3273 11.8531 13.5108 11.682 13.682C10.8381 14.5259 9.69347 15 8.5 15C7.30653 15 6.16193 14.5259 5.31802 13.682C5.14686 13.5108 4.99091 13.3273 4.85104 13.1335L2.22361 14.4472L1.77639 13.5528L4.35907 12.2614C4 12 4 11.5 4 11.5V10H1V9H4V8.91605C3.99991 7.90711 4.23469 6.91196 4.68575 6.00947L4.72883 5.92343L1.77639 4.44721L2.22361 3.55279L5 4.94098Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const CodeCommentIcon = createIcon({
  name: 'code-comment',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M5.4931 4.99999L6.0068 1.91779L6.9932 2.08218L6.5069 4.99999H10.4931L11.0068 1.91779L11.9932 2.08218L11.5069 4.99999H14V5.99999H11.3402L10.6736 9.99998H14V11H10.5069L9.9932 14.0822L9.0068 13.9178L9.4931 11H5.5069L4.9932 14.0822L4.0068 13.9178L4.4931 11H2V9.99998H4.65977L5.32644 5.99999H2V4.99999H5.4931ZM6.34023 5.99999L5.67356 9.99998H9.65977L10.3264 5.99999H6.34023Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const EnterIcon = createIcon({
  name: 'enter',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M9 3.5C9 3.22386 9.22386 3 9.5 3H13C13.5523 3 14 3.44772 14 4V9C14 9.55228 13.5523 10 13 10H3.70711L5.85355 12.1464C6.04882 12.3417 6.04882 12.6583 5.85355 12.8536C5.65829 13.0488 5.34171 13.0488 5.14645 12.8536L2.14645 9.85355C1.95118 9.65829 1.95118 9.34171 2.14645 9.14645L5.14645 6.14645C5.34171 5.95118 5.65829 5.95118 5.85355 6.14645C6.04882 6.34171 6.04882 6.65829 5.85355 6.85355L3.70711 9H13V4H9.5C9.22386 4 9 3.77614 9 3.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const MagicIcon = createIcon({
  name: 'magic',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M11.7092 7.5C11.1159 8.96592 9.67869 10 8 10C6.32131 10 4.88415 8.96592 4.29076 7.5C4.88415 6.03409 6.32131 5 8 5C9.67869 5 11.1159 6.03409 11.7092 7.5ZM12 5.99951C11.0878 4.78534 9.6356 4 8 4C6.3644 4 4.91223 4.78534 4 5.99951C4.00026 3.7906 5.79102 2 8 2C10.209 2 11.9997 3.7906 12 5.99951ZM12.7711 7.5C12.9198 7.02648 13 6.5226 13 6C13 3.23858 10.7614 1 8 1C5.23858 1 3 3.23858 3 6C3 6.5226 3.08018 7.02648 3.2289 7.5C3.08018 7.97352 3 8.4774 3 9C3 11.7614 5.23858 14 8 14C10.7614 14 13 11.7614 13 9C13 8.4774 12.9198 7.97352 12.7711 7.5ZM12 9.00049C11.0878 10.2147 9.6356 11 8 11C6.3644 11 4.91223 10.2147 4 9.00049C4.00026 11.2094 5.79102 13 8 13C10.209 13 11.9997 11.2094 12 9.00049Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const InPersonIcon = createIcon({
  name: 'in-person',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M6.14286 2C4.88005 2 3.85714 3.02271 3.85714 4.2839C3.85714 5.54509 4.88005 6.5678 6.14286 6.5678C7.40566 6.5678 8.42857 5.54509 8.42857 4.2839C8.42857 3.02271 7.40566 2 6.14286 2ZM2.85714 4.2839C2.85714 2.46981 4.32838 1 6.14286 1C7.95733 1 9.42857 2.46981 9.42857 4.2839C9.42857 6.09799 7.95733 7.5678 6.14286 7.5678C4.32838 7.5678 2.85714 6.09799 2.85714 4.2839ZM9.35714 7.07143C9.35714 5.76961 10.4125 4.71429 11.7143 4.71429C13.0161 4.71429 14.0714 5.76961 14.0714 7.07143C14.0714 8.37324 13.0161 9.42857 11.7143 9.42857C10.4125 9.42857 9.35714 8.37324 9.35714 7.07143ZM11.7143 5.71429C10.9648 5.71429 10.3571 6.3219 10.3571 7.07143C10.3571 7.82096 10.9648 8.42857 11.7143 8.42857C12.4638 8.42857 13.0714 7.82096 13.0714 7.07143C13.0714 6.3219 12.4638 5.71429 11.7143 5.71429ZM4.28571 10.3517C3.02324 10.3517 2 11.3747 2 12.6369V13.9915H10.2857V12.6369C10.2857 11.3747 9.26248 10.3517 8 10.3517H4.28571ZM1 12.6369C1 10.8222 2.47118 9.3517 4.28571 9.3517H8C9.81454 9.3517 11.2857 10.8222 11.2857 12.6369V14.9915H1V12.6369ZM14 13.1071C14 12.1012 13.1845 11.2857 12.1786 11.2857V10.2857C13.7368 10.2857 15 11.5489 15 13.1071V15H12.1786V14H14V13.1071Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const VirtualIcon = createIcon({
  name: 'virtual',
  iconSize: 16,
  transform: '',
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3.93782 3.6204L8.26077 6.50237L8.25077 6.52237L8.96722 7L8.25078 7.47763L8.26078 7.49763L3.93783 10.3796L3.92783 10.3596L3 10.9781V3.02185L3.92782 3.6404L3.93782 3.6204ZM3.55 11.84L9.55 7.84L9.54 7.82C9.81 7.64 10 7.35 10 7C10 6.65 9.81 6.36 9.54 6.18L9.55 6.16L3.55 2.16L3.54 2.18L3.53769 2.17846C3.45659 2.12462 3.36676 2.07669 3.26819 2.04409C3.18501 2.01658 3.09561 2 3 2C2.45 2 2 2.45 2 3V11C2 11.55 2.45 12 3 12C3.09561 12 3.18499 11.9834 3.26816 11.9559C3.36674 11.9233 3.45658 11.8754 3.53769 11.8215L3.54 11.82L3.55 11.84ZM11 2.04028V12.0016H12V2.04028L11 2.04028Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
});

export const GuidesIcon = createIcon({
  name: 'guides',
  iconSize: 16,
  transform: '',
  path: (
    <>
      <path
        d="M2.5 5.5L7.99998 2.5L13.5 5.5L7.99998 8.5L2.5 5.5Z"
        fill="currentColor"
        opacity="0.2"
      />
      <path
        clipRule="evenodd"
        d="M7.7608 2.06105C7.91004 1.97965 8.09041 1.97965 8.23965 2.06105L13.7397 5.06105C13.9003 5.14867 14.0002 5.31703 14.0002 5.5C14.0002 5.68297 13.9003 5.85133 13.7397 5.93895L8.23965 8.93895C8.09041 9.02035 7.91004 9.02035 7.7608 8.93895L2.26082 5.93895C2.10019 5.85133 2.00024 5.68297 2.00024 5.5C2.00024 5.31703 2.10019 5.14867 2.26082 5.06105L7.7608 2.06105ZM8.00023 3.06954L3.5444 5.5L8.00022 7.93046L12.4561 5.5L8.00023 3.06954ZM2.06115 7.76058C2.19338 7.51815 2.4971 7.42882 2.73952 7.56106L8.0001 10.4305L13.2607 7.56106C13.5031 7.42882 13.8068 7.51815 13.939 7.76058C14.0713 8.003 13.982 8.30672 13.7395 8.43895L8.23953 11.439C8.09029 11.5204 7.90991 11.5204 7.76067 11.439L2.26067 8.43895C2.01824 8.30672 1.92892 8.003 2.06115 7.76058ZM2.73952 10.0611C2.4971 9.92882 2.19338 10.0182 2.06115 10.2606C1.92892 10.503 2.01824 10.8067 2.26067 10.939L7.76065 13.939C7.90989 14.0204 8.09027 14.0204 8.23951 13.939L13.7395 10.939C13.9819 10.8067 14.0713 10.503 13.939 10.2606C13.8068 10.0182 13.5031 9.92882 13.2607 10.0611L8.00008 12.9305L2.73952 10.0611Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
});

export const DuplicateIcon = createIcon({
  name: 'duplicate',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M14 2H6V3H5V2C5 1.44772 5.44772 1 6 1H14C14.5523 1 15 1.44772 15 2V10C15 10.5523 14.5523 11 14 11H13V10H14V2ZM2 14V6H10V14H2ZM1 6C1 5.44772 1.44772 5 2 5H10C10.5523 5 11 5.44772 11 6V14C11 14.5523 10.5523 15 10 15H2C1.44772 15 1 14.5523 1 14V6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const ClockIcon = createIcon({
  name: 'clock',
  transform: '',
  iconSize: 16,
  path: (
    <path
      clipRule="evenodd"
      d="M0.5 8.00003C0.5 3.85789 3.85786 0.500031 8 0.500031C12.1421 0.500031 15.5 3.85789 15.5 8.00003C15.5 12.1422 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1422 0.5 8.00003ZM8 1.50003C4.41015 1.50003 1.5 4.41018 1.5 8.00003C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8.00003C14.5 4.41018 11.5899 1.50003 8 1.50003ZM7.5 8.00003V3.50003H8.5V7.79292L11.3536 10.6465L10.6464 11.3536L7.64645 8.35358C7.55268 8.25982 7.5 8.13264 7.5 8.00003Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const GraphIcon = createIcon({
  name: 'graph',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M0 0H1V14H15V15H0V0ZM8 3V0H9V3H10V8H7V3H8ZM9 4H8V7H9V4ZM3 5V4H4V5H5V10H4V12H3V10H2V5H3ZM4 6H3V9H4V6ZM13 6H12V11H13V13H14V11H15V6H14V4H13V6ZM13 7V10H14V7H13Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const UserIcon = createIcon({
  name: 'user',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M8.9581 2.19055C8.50153 2.00125 7.99908 1.95159 7.51429 2.04786C7.0295 2.14412 6.58414 2.38198 6.23453 2.73135C5.88492 3.08073 5.64677 3.52593 5.55018 4.01065C5.4536 4.49538 5.50292 4.99786 5.69191 5.45456C5.8809 5.91125 6.20107 6.30165 6.61194 6.57638C7.0228 6.85111 7.50591 6.99784 8.00017 6.998C8.32834 6.99811 8.65332 6.93358 8.95656 6.80809C9.25979 6.68261 9.53534 6.49863 9.76747 6.26665C9.9996 6.03467 10.1838 5.75925 10.3095 5.4561C10.4351 5.15295 10.4999 4.82801 10.5 4.49984C10.5002 4.00558 10.3538 3.52237 10.0793 3.11132C9.80485 2.70027 9.41467 2.37984 8.9581 2.19055ZM7.31952 1.06701C7.99831 0.932223 8.70182 1.00175 9.34109 1.26679C9.98036 1.53184 10.5267 1.9805 10.911 2.55603C11.2952 3.13157 11.5002 3.80813 11.5 4.50017C11.4999 4.95966 11.4092 5.41463 11.2332 5.83909C11.0572 6.26355 10.7994 6.64919 10.4743 6.97399C10.1493 7.2988 9.76351 7.5564 9.33893 7.7321C8.91436 7.9078 8.45933 7.99815 7.99983 7.998C7.3078 7.99777 6.63137 7.79233 6.05609 7.40767C5.48081 7.023 5.03252 6.47638 4.7679 5.83693C4.50328 5.19749 4.43423 4.49393 4.56946 3.81524C4.7047 3.13654 5.03815 2.51319 5.52766 2.02401C6.01717 1.53483 6.64074 1.20179 7.31952 1.06701ZM5.5076 9.996C4.84456 9.996 4.20867 10.2594 3.73983 10.7282C3.27099 11.1971 3.0076 11.833 3.0076 12.496V13.992H13V12.496C13 11.833 12.7366 11.1971 12.2678 10.7282C11.7989 10.2594 11.163 9.996 10.5 9.996H5.5076ZM14 12.496C14 11.5677 13.6313 10.6775 12.9749 10.0211C12.3185 9.36475 11.4283 8.996 10.5 8.996H5.5076C4.57934 8.996 3.6891 9.36475 3.03273 10.0211C2.37635 10.6775 2.0076 11.5677 2.0076 12.496V14.992H13H14V14.493V12.496Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const CollectionsIcon = createIcon({
  name: 'collections',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0H5.5C5.89782 0 6.27936 0.158035 6.56066 0.43934C6.84196 0.720644 7 1.10217 7 1.5V5.5C7 5.89783 6.84196 6.27936 6.56066 6.56066C6.27936 6.84196 5.89783 7 5.5 7H1.5C1.10217 7 0.720644 6.84196 0.43934 6.56066C0.158035 6.27936 0 5.89782 0 5.5V1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934ZM1.5 1C1.36739 1 1.24021 1.05268 1.14645 1.14645C1.05268 1.24021 1 1.36739 1 1.5V5.5C1 5.63261 1.05268 5.75978 1.14645 5.85355C1.24022 5.94732 1.36739 6 1.5 6H5.5C5.63261 6 5.75978 5.94732 5.85355 5.85355C5.94732 5.75978 6 5.63261 6 5.5V1.5C6 1.36739 5.94732 1.24022 5.85355 1.14645C5.75978 1.05268 5.63261 1 5.5 1H1.5ZM8.43934 0.43934C8.72065 0.158035 9.10217 0 9.5 0H13.5C13.8978 0 14.2794 0.158035 14.5607 0.43934C14.842 0.720644 15 1.10217 15 1.5V5.5C15 5.89783 14.842 6.27936 14.5607 6.56066C14.2794 6.84196 13.8978 7 13.5 7H9.5C9.10217 7 8.72064 6.84196 8.43934 6.56066C8.15804 6.27936 8 5.89783 8 5.5V1.5C8 1.10217 8.15804 0.720644 8.43934 0.43934ZM9.5 1C9.36739 1 9.24022 1.05268 9.14645 1.14645C9.05268 1.24022 9 1.36739 9 1.5V5.5C9 5.63261 9.05268 5.75978 9.14645 5.85355C9.24022 5.94732 9.36739 6 9.5 6H13.5C13.6326 6 13.7598 5.94732 13.8536 5.85355C13.9473 5.75978 14 5.63261 14 5.5V1.5C14 1.36739 13.9473 1.24022 13.8536 1.14645C13.7598 1.05268 13.6326 1 13.5 1H9.5ZM0.43934 8.43934C0.720644 8.15804 1.10217 8 1.5 8H5.5C5.89783 8 6.27936 8.15804 6.56066 8.43934C6.84196 8.72064 7 9.10217 7 9.5V13.5C7 13.8978 6.84196 14.2794 6.56066 14.5607C6.27936 14.842 5.89783 15 5.5 15H1.5C1.10217 15 0.720644 14.842 0.43934 14.5607C0.158035 14.2794 0 13.8978 0 13.5V9.5C0 9.10217 0.158035 8.72065 0.43934 8.43934ZM1.5 9C1.36739 9 1.24022 9.05268 1.14645 9.14645C1.05268 9.24022 1 9.36739 1 9.5V13.5C1 13.6326 1.05268 13.7598 1.14645 13.8536C1.24022 13.9473 1.36739 14 1.5 14H5.5C5.63261 14 5.75978 13.9473 5.85355 13.8536C5.94732 13.7598 6 13.6326 6 13.5V9.5C6 9.36739 5.94732 9.24022 5.85355 9.14645C5.75978 9.05268 5.63261 9 5.5 9H1.5ZM8.43934 8.43934C8.72064 8.15804 9.10217 8 9.5 8H13.5C13.8978 8 14.2794 8.15804 14.5607 8.43934C14.842 8.72064 15 9.10217 15 9.5V13.5C15 13.8978 14.842 14.2794 14.5607 14.5607C14.2794 14.842 13.8978 15 13.5 15H9.5C9.10217 15 8.72064 14.842 8.43934 14.5607C8.15804 14.2794 8 13.8978 8 13.5V9.5C8 9.10217 8.15804 8.72064 8.43934 8.43934ZM9.5 9C9.36739 9 9.24022 9.05268 9.14645 9.14645C9.05268 9.24022 9 9.36739 9 9.5V13.5C9 13.6326 9.05268 13.7598 9.14645 13.8536C9.24022 13.9473 9.36739 14 9.5 14H13.5C13.6326 14 13.7598 13.9473 13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5V9.5C14 9.36739 13.9473 9.24022 13.8536 9.14645C13.7598 9.05268 13.6326 9 13.5 9H9.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const ComponentsIcon = createIcon({
  name: 'components',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M7.3479 1.13807C7.46631 1.08732 7.60034 1.08732 7.71875 1.13807L14.748 4.15062C14.9211 4.22479 15.0333 4.39497 15.0333 4.58327C15.0333 4.77157 14.9211 4.94175 14.748 5.01592L7.71875 8.02847C7.60034 8.07922 7.46631 8.07922 7.3479 8.02847L0.318614 5.01592C0.145541 4.94175 0.0333252 4.77157 0.0333252 4.58327C0.0333252 4.39497 0.145541 4.22479 0.318614 4.15062L7.3479 1.13807ZM1.69898 4.58327L7.53333 7.0837L13.3677 4.58327L7.53333 2.08284L1.69898 4.58327ZM0.318614 8.02847L0.689459 7.16317L7.53333 10.0963L14.3772 7.16317L14.748 8.02847L7.53333 11.1205L0.318614 8.02847ZM0.318614 11.041L0.689459 10.1757L7.53333 13.1088L14.3772 10.1757L14.748 11.041L7.53333 14.133L0.318614 11.041Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const IntegrationsIcon = createIcon({
  name: 'integrations',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M9 9V6H1V2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V9H9ZM10 5H2V2H14V8H10V5ZM8 7V10H15V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V7H8ZM7 11H14V14H2V8H7V11Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const TabsIcon = createIcon({
  name: 'tabs',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M1.07143 0.9375H13.9286C14.0025 0.9375 14.0625 0.997461 14.0625 1.07143V13.9286C14.0625 14.0025 14.0025 14.0625 13.9286 14.0625H1.07143C0.997462 14.0625 0.9375 14.0025 0.9375 13.9286V1.07143C0.9375 0.997462 0.997461 0.9375 1.07143 0.9375ZM0 1.07143C0 0.479694 0.479695 0 1.07143 0H13.9286C14.5203 0 15 0.479695 15 1.07143V13.9286C15 14.5203 14.5203 15 13.9286 15H1.07143C0.479694 15 0 14.5203 0 13.9286V1.07143ZM7.03393 11.7857L7.03393 7.97153H3.21429V7.03403H7.03393V3.21429H7.97143V7.03403H11.7857V7.97153H7.97143V11.7857H7.03393Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const DataRefreshIcon = createIcon({
  name: 'data-refresh',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M11.2011 2.30118C10.1203 1.53178 8.82664 1.11832 7.49999 1.11829L7.50001 0C9.05913 2.82953e-05 10.5795 0.485945 11.8496 1.39017C13.1198 2.29439 14.0765 3.57196 14.5868 5.0452C15.0972 6.51843 15.1357 8.11409 14.6971 9.61023C14.3304 10.861 13.6454 11.9902 12.715 12.8904H14.9368V14.0087H10.9071V9.97905H12.0254V11.9998C12.7724 11.2486 13.3236 10.32 13.6239 9.29561C13.9972 8.02255 13.9644 6.66481 13.5302 5.41124C13.0959 4.15767 12.2818 3.07058 11.2011 2.30118ZM2.28505 2.10986H0.063237V0.991569H4.09287V5.02121H2.97458V3.00043C2.22762 3.75168 1.67641 4.68026 1.37607 5.70465C1.00283 6.97771 1.03561 8.33545 1.46984 9.58902C1.90408 10.8426 2.71819 11.9297 3.79894 12.6991C4.87969 13.4685 6.17336 13.8819 7.50001 13.882L7.49999 15.0003C5.94087 15.0002 4.42051 14.5143 3.15038 13.6101C1.88025 12.7059 0.92348 11.4283 0.413151 9.95506C-0.0971774 8.48182 -0.135697 6.88617 0.30295 5.39002C0.669642 4.1393 1.35456 3.0101 2.28505 2.10986Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const ExploreIcon = createIcon({
  name: 'explore',
  transform: '',
  path: (
    <path
      clipRule="evenodd"
      d="M0,7.5C0,3.4,3.4,0,7.5,0C11.6,0,15,3.4,15,7.5c0,4.1-3.4,7.5-7.5,7.5C3.4,15,0,11.6,0,7.5z M7.5,1
      C3.9,1,1,3.9,1,7.5C1,11.1,3.9,14,7.5,14c3.6,0,6.5-2.9,6.5-6.5C14,3.9,11.1,1,7.5,1z M10.9,4.1C11,4.3,11,4.5,10.9,4.7l-2,4
      c0,0.1-0.1,0.2-0.2,0.2l-4,2C4.5,11,4.3,11,4.1,10.9C4,10.7,4,10.5,4.1,10.3l2-4c0-0.1,0.1-0.2,0.2-0.2l4-2C10.5,4,10.7,4,10.9,4.1z
       M6.9,6.9L5.6,9.4l2.5-1.3l1.3-2.5L6.9,6.9z"
      fill="currentColor"
      fillRule="evenodd"
    />
  )
});

export const FiltersIcon = createIcon({
  name: 'filters',
  transform: '',
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M14.5,2.7H0.5C0.2,2.7,0,2.9,0,3.2c0,0.3,0.2,0.5,0.5,0.5h13.9c0.3,0,0.5-0.2,0.5-0.5
        C15,2.9,14.8,2.7,14.5,2.7z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M12.3,7H2.7C2.4,7,2.1,7.2,2.1,7.5c0,0.3,0.2,0.5,0.5,0.5h9.6c0.3,0,0.5-0.2,0.5-0.5C12.9,7.2,12.6,7,12.3,7z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10.2,11.3H4.8c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h5.4c0.3,0,0.5-0.2,0.5-0.5
        C10.7,11.5,10.5,11.3,10.2,11.3z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
});
